var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "col-container-card-annonce col-12 col-sm-12 col-md-6 col-lg-4",
      class: _vm.classWithConditions
    },
    [
      _c("div", {
        staticClass: "placeholder-card-annonce",
        class: {
          "placeholder-gradient": _vm.isGradient,
          "placeholder-animated": _vm.isAnimated
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41c6a608", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41c6a608","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/PlaceholderCardAnnonce.vue
// module id = BVRh
// module chunks = 0